// src/components/common/ImpersonationBanner.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  EyeIcon, 
  ArrowLeftOnRectangleIcon, 
  ShieldCheckIcon,
  BuildingOffice2Icon
} from '@heroicons/react/24/outline';

export const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatedLubricentro, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonatedLubricentro) {
    return null;
  }

  const handleExit = () => {
    stopImpersonation();
    navigate('/superadmin');
  };

  return (
    <div className="sticky top-0 z-50 bg-gradient-to-r from-amber-600 via-orange-600 to-amber-700 text-white px-4 py-2.5 shadow-lg border-b border-amber-500/40 backdrop-blur-md">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        <div className="flex items-center space-x-3 text-sm">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-black/20 text-amber-200 ring-1 ring-white/20">
            <EyeIcon className="h-4 w-4" />
          </div>
          <div>
            <span className="font-extrabold uppercase tracking-wider text-[11px] bg-amber-900/50 px-2 py-0.5 rounded-full mr-2">
              Modo Soporte
            </span>
            <span className="font-semibold text-white">
              Visualizando como: <strong>{impersonatedLubricentro.fantasyName || impersonatedLubricentro.responsable}</strong>
            </span>
            <span className="text-xs text-amber-100/90 ml-2 hidden md:inline">
              (ID: {impersonatedLubricentro.id})
            </span>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <button
            onClick={() => navigate(`/superadmin/lubricentros/${impersonatedLubricentro.id}`)}
            className="text-xs font-semibold px-3 py-1 bg-white/10 hover:bg-white/20 rounded-lg transition-colors border border-white/20 text-white"
          >
            Ficha SuperAdmin
          </button>
          <button
            onClick={handleExit}
            className="flex items-center space-x-1.5 bg-black/40 hover:bg-black/60 text-white text-xs font-bold px-3.5 py-1.5 rounded-lg shadow-sm transition-all border border-white/20 active:scale-95"
          >
            <ArrowLeftOnRectangleIcon className="h-4 w-4 text-amber-300" />
            <span>Salir del Modo Soporte</span>
          </button>
        </div>
      </div>
    </div>
  );
};
